import type { IListResponse, IPerson } from '@dakedake/types'
import { request } from '@umijs/max'

/** 添加人物 POST /backend/person/add */
export async function personAdd(body: IPerson, options?: Record<string, any>) {
  return request<{ data: IPerson, success: boolean, message: string }>('/backend/person/add', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 添加人物 POST /backend/person/adds */
export async function personAdds(body: IPerson[], options?: Record<string, any>) {
  return request<{ data: IPerson[], success: boolean, message: string }>('/backend/person/adds', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 更新人物 POST /backend/person/edit */
export async function personEdit(body: IPerson, options?: Record<string, any>) {
  return request<{ data: IPerson, success: boolean, message: string }>(`/backend/person/${body.id}`, {
    method: 'PUT',
    data: body,
    ...options
  })
}

/** 删除人物 POST /backend/person/delete */
export async function personDelete(body: { id?: number }, options?: Record<string, any>) {
  return request<{ data: IPerson, success: boolean, message: string }>(`/backend/person/${body.id}`, {
    method: 'DELETE',
    data: body,
    ...options
  })
}

/** 获取人物列表 GET /backend/person/list */
export async function personList(
  params: {
    // query
    /** 当前的页码 */
    current?: number
    /** 页面的容量 */
    pageSize?: number
    [key: string]: any
  },
  options?: Record<string, any>
) {
  return request<IListResponse<IPerson>>('/backend/person/list', {
    method: 'GET',
    params: {
      ...params
    },
    ...options
  })
}

/** 获取人物详情 GET /backend/person/{id} */
export async function personDetail(id?: number, options?: Record<string, any>) {
  return request<{ data: IPerson, success: boolean, message: string }>(`/backend/person/${id}`, {
    method: 'GET',
    ...options
  })
}

/** 更新封面 POST /backend/person/editCover */
export async function personEditCover(body: { id?: number, cover?: number | null }, options?: Record<string, any>) {
  return request<{ data: IPerson, success: boolean, message: string }>('/backend/person/editCover', {
    method: 'POST',
    data: body,
    ...options
  })
}

/** 查询重复数据 GET /backend/person/findDuplicates */
export async function personFindDuplicates(options?: Record<string, any>) {
  return request<{ data: { duplicates: any[], totalDuplicates: number }, success: boolean, message: string }>('/backend/person/findDuplicates', {
    method: 'GET',
    ...options
  })
}

/** 合并重复数据 POST /backend/person/mergeDuplicates */
export async function personMergeDuplicates(body: { sources?: string[] }, options?: Record<string, any>) {
  return request<{ data: { mergedCount: number, totalDuplicates: number }, success: boolean, message: string }>('/backend/person/mergeDuplicates', {
    method: 'POST',
    data: body,
    ...options
  })
}
